export function getDateWithOffset(offsetInDays: number) {
  return new Date(new Date().setDate(new Date().getDate() + offsetInDays));
}

export function getPreviousMonth() {
  return new Date(new Date().setMonth(new Date().getMonth() - 1));
}
